package szlot

import visage.core.AComponent
import visage.core.AScene
import visage.core.Components

class GreeterSceneState

class MGreeterScene(props: GreeterProps) :
    AScene<GreeterProps, GreeterModel, GreeterSceneState, GreeterControllerFe>(props) {

    override fun createController(): GreeterControllerFe = GreeterControllerFe(props, this)

    override fun initState(): GreeterSceneState = GreeterSceneState()

    override fun Components.render(children: List<AComponent<*>>) {
        +this@MGreeterScene.model.greeting
    }
}

/** Convenience builder to mount the scene inside a Visage render block. */
fun Components.GreeterScene(props: GreeterProps) = registerComponent(MGreeterScene(props)) {}
